import React from "react";
import { Button, Stack } from "@mui/material";
import styled from "styled-components";
import CommitIcon from "@mui/icons-material/Commit";
import CallMergeIcon from "@mui/icons-material/CallMerge";
import GradingIcon from "@mui/icons-material/Grading";
import PlayCircleOutlineIcon from "@mui/icons-material/PlayCircleOutline";
import GroupsIcon from "@mui/icons-material/Groups";
import HotelIcon from "@mui/icons-material/Hotel";
import { format } from "date-fns";
import Link from "@mui/material/Link";
import LinkOffIcon from "@mui/icons-material/LinkOff";

const Span = styled.span`
    font-size: 16px;
    font-weight: 300;
    opacity: 0.35;
    color: ${({ theme }) => theme.palette.text.secondary};
`;

const BorderedStack = styled(Stack)`
    border: ${({ theme }) => `3px dashed ${theme.palette.background.paper}`};
    border-radius: 14px;
    // width: 100%;
`;

const BodyText = styled.p`
    font-size: 14px;
    font-weight: 300;
    margin: 0;
`;

const AssignIcon = ({ name, isInvalid }) => {
    if (isInvalid) return <LinkOffIcon color="warning" />;
    if (name === "commits")
        return <CommitIcon style={{ width: "50", height: "auto", opacity: "0.3" }} />;
    if (name === "deployments")
        return <PlayCircleOutlineIcon style={{ width: "50", height: "auto", opacity: "0.3" }} />;
    if (name === "merge-requests")
        return <CallMergeIcon style={{ width: "50", height: "auto", opacity: "0.3" }} />;
    if (name === "reviews")
        return <GradingIcon style={{ width: "50", height: "auto", opacity: "0.3" }} />;
    if (name === "collaboration")
        return <GroupsIcon style={{ width: "50", height: "auto", opacity: "0.3" }} />;
    return <HotelIcon style={{ width: "50", height: "auto", opacity: "0.3" }} />;
};

const IntegratedInactive = ({ name, lastActiveAt, firstScrappedDate, isInvalid, skipAction }) => {
    const getText = () => {
        if (isInvalid) {
            return (
                <>
                    <Span style={{ marginBottom: "3rem" }}>
                        A required integration has been invalidated and data have stopped flowing.
                        You might be seeing partial or missing data. Please re-integrate. If you
                        think this is wrong, please contact us.
                    </Span>
                    {skipAction && (
                        <Button onClick={() => skipAction(true)}>
                            I Understand. Show me the data anyways.
                        </Button>
                    )}
                </>
            );
        }
        if (lastActiveAt) {
            return (
                <Span style={{ marginBottom: "3rem" }}>
                    Seems like you had no {name} activity for that period Your last {name} activity
                    was at {format(new Date(lastActiveAt * 1000 || lastActiveAt), "PPPP")}
                </Span>
            );
        }
        if (firstScrappedDate) {
            return (
                <>
                    {name === "deployments" ? (
                        <>
                            <Span style={{ marginBottom: "3rem" }}>
                                No supported deployment data was found into your account since{" "}
                                {format(
                                    new Date(firstScrappedDate * 1000 || firstScrappedDate),
                                    "PPPP"
                                )}
                            </Span>
                            <BodyText>
                                Depending on your CI tool/deployment target some deployments will
                                not appear.
                            </BodyText>
                        </>
                    ) : (
                        <>
                            <Span style={{ marginBottom: "3rem" }}>
                                Seems like you had no {name} activity since{" "}
                                {format(
                                    new Date(firstScrappedDate * 1000 || firstScrappedDate),
                                    "PPPP"
                                )}
                            </Span>
                            <BodyText>Feel free to review your integrated accounts.</BodyText>
                        </>
                    )}
                    <BodyText style={{ marginBottom: "2rem" }}>
                        If you feel that this is a mistake please{" "}
                        <Link href="/upgrade/inquiry">contact us</Link> and we will investigate it
                        as soon as possible.
                    </BodyText>
                </>
            );
        }
        return (
            <>
                <Span style={{ marginBottom: "3rem" }}>Seems like you had no {name} activity</Span>
                <BodyText>Feel free to review your integrated accounts.</BodyText>
                <BodyText style={{ marginBottom: "2rem" }}>
                    If you feel that this is a mistake please{" "}
                    <Link href="/upgrade/inquiry">contact us</Link> and we will investigate it as
                    soon as possible.
                </BodyText>
            </>
        );
    };

    return (
        <BorderedStack
            spacing={2}
            direction="column"
            justifyContent="center"
            alignItems="center"
            p={10}
            m={3}
        >
            {AssignIcon({ name, isInvalid })}
            <Stack alignItems="center">{getText()}</Stack>
        </BorderedStack>
    );
};

export default IntegratedInactive;
